/** Текст тултипа для read-only режима демо-магазина. */
export const DEMO_SHOP_READONLY_TOOLTIP =
  'Чтобы изменять данные, добавьте свой магазин WB.'

type ShopLike = { id: string; sid?: string | null; role?: string | null }

/** Демо-магазин: sid=demo или роль доступа demo в связи user_shop_relations. */
export function isDemoShop(shop: ShopLike | null | undefined): boolean {
  if (!shop) return false
  const sid = typeof shop.sid === 'string' ? shop.sid.trim().toLowerCase() : ''
  const role = typeof shop.role === 'string' ? shop.role.trim().toLowerCase() : ''
  return sid === 'demo' || role === 'demo'
}

/**
 * Магазины для селектора в шапке: демо скрыт для всех, кроме админа.
 */
export function filterShopsForSelector<T extends ShopLike>(shops: T[], isAdmin: boolean): T[] {
  if (isAdmin) return shops
  return shops.filter((s) => !isDemoShop(s))
}

/**
 * Магазин для редиректа с /rnp: предпочитаем не-демо, если есть; иначе остаётся демо.
 */
export function pickShopForRedirect<T extends ShopLike>(
  shops: T[],
  savedShopId: string | null | undefined,
  isAdmin: boolean,
): T | undefined {
  if (!shops.length) return undefined
  const selectable = filterShopsForSelector(shops, isAdmin)
  const pool = selectable.length > 0 ? selectable : shops
  if (savedShopId) {
    const saved = pool.find((s) => s.id === savedShopId)
    if (saved) return saved
  }
  return pool[0]
}
